import React from "react";
import FooterLinkColumn from "./FooterLinkColumn";
import SocialIcon from "./SocialIcon";
import { faTwitter, faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <>
      <footer className="bg-gray-900 text-white pt-8 pb-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4">
              <h3 className="text-3xl font-semibold mb-4 md:mb-0">
                We are here to help
              </h3>
              <p className="text-lg mt-0 mb-2 text-gray-500">
                We look forward to having you be part of our community.
              </p>
              <div className="mt-6">
                <SocialIcon icon={faTwitter} url="https://twitter.com" />
                <SocialIcon icon={faFacebook} url="https://www.facebook.com" />
                <SocialIcon icon={faInstagram} url="https://instagram.com" />
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <FooterLinkColumn 
                  header="Useful Links"
                  items={[
                    {
                      label: 'About Us',
                      link: '/about'
                    },
                    {
                      label: 'Pricing',
                      link: '/pricing'
                    },
                    {
                      label: 'Solutions',
                      link: '/solutions'
                    },
                  ]}
                />
                <FooterLinkColumn 
                  header="Other Resources"
                  items={[
                    {
                      label: 'Press',
                      link: '/press'
                    },
                    {
                      label: 'Terms & Conditions',
                      link: '/toc'
                    },
                    {
                      label: 'Privacy Policy',
                      link: '/privacy'
                    },
                  ]}
                />
              </div>
            </div>
          </div>          
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-gray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://www.creative-tim.com"
                  className="text-gray-500"
                >
                  Your Company
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;